<template>
  <div class="__menu_button" @click="open()">
    <font-awesome-icon :icon="['fas', 'bars']" />
  </div>
</template>

<script>
export default {
  name: "MenuButton",
  methods: {
    open() {
      this.$emit("open");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../theme.scss";

.__menu_button {
  width: 56px;
  height: 56px;
  font-size: 26px;
  line-height: 56px;
  text-align: center;
  color: $secondary;
  background-color: $primary;
  border-radius: 100%;
  cursor: pointer;
  margin: 15px 25px;

  &:hover {
    color: white;
  }
}
</style>
